module.exports = __webpack_public_path__ + "img/appsumo_login_image.a1b52dd8.png";